import React, { Suspense } from "react";
import Markup from "./markup/Markup";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
import "./css/plugins.css";
import "./css/style.css";
import "./css/templete.css";
import "./css/skin/skin-1.css";
import "./plugins/slick/slick.min.css";
import "./plugins/slick/slick-theme.min.css";

import Login from "./markup/Pages/Loginpage2";
import SignUp from "./markup/Pages/Register2";
import Homepage from "./markup/Pages/Homepage1";
import Error404 from "./markup/Pages/Error404";
import Payment from "./markup/Pages/Payment";
import Browsejobfilterlist from "./markup/Pages/Browsejobfilterlist";
import PackagePlan from "./markup/Pages/PackagePlan";
import ProfessionalSignup from "./markup/Pages/ProfessionalSignup";
import LoginPro from "./markup/Pages/LoginPro";

//const SignUp = lazy(() => import('./markup/Pages/Register2'));
//const ForgotPassword = lazy(() => import('./markup/pages/ForgotPassword'));
/*  const Login = lazy(() => {
    return new Promise(resolve => {
    setTimeout(() => resolve(import('./markup/Pages/Loginpage2')), 500);
  });
});  */

function App(props) {
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   checkAutoLogin(dispatch, props.history);
  // }, [dispatch, props.history]);

  let routes = (
    <Switch>
      <Route path="/login" component={Login} />
      {/* <Route path="/register" component={SignUp} /> */}
      <Route path="/register" component={SignUp} />
      <Route path="/Checkout/:id/:email/:userid" component={Payment} />
      <Route path="/PackagePlan" exact component={PackagePlan} />
      <Route path="/Professional-Signup" exact component={ProfessionalSignup} /> 
      <Route path="/Professional-login" exact component={LoginPro} />
      {/* <Route path='/login-3' exact component={Loginpage3} /> */}
      {/* <Route path="/" exact component={Landing} />; */}
      <Route path="/" exact component={Homepage} />;
      <Route
        path="/browse-job-filter-list"
        exact
        component={Browsejobfilterlist}
      />
      <Route path="*" component={Error404} />
    </Switch>
  );

  if (props.isAuthenticated) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Markup />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {routes}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));

//export default App;
